export default {"src":"/_next/static/media/cash.645ae07e.svg","height":51,"width":50};